'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var slider = require('@react-aria/slider');
var slider$1 = require('@react-stately/slider');
var common = require('@andes/common');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var focus = require('@react-aria/focus');
var utils = require('@react-aria/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
const namespace = 'andes-slider';
const thumbNamespace = "".concat(namespace, "__thumb");
const _excluded = ["id", "index", "disabled", "state", "trackRef"];
const SliderThumb = _ref => {
  let {
      id,
      index,
      disabled,
      state,
      trackRef
    } = _ref,
    outputProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  const [zoomOutputHiding, changeZoomOutputHiding] = React.useState(false);
  const {
    getThumbPercent,
    getThumbValueLabel,
    isThumbDragging
  } = state;
  const inputRef = React.useRef(null);
  const {
    focusProps,
    isFocusVisible
  } = focus.useFocusRing();
  const {
    inputProps,
    thumbProps
  } = slider.useSliderThumb({
    index,
    trackRef,
    inputRef,
    isDisabled: disabled
  }, state);
  thumbProps.style.left = '50%';
  inputProps.tabIndex = undefined;
  const dragging = isThumbDragging(index);
  const thumbClassnames = classNames__default["default"](thumbNamespace, {
    ["".concat(thumbNamespace, "--focus")]: isFocusVisible,
    ["".concat(thumbNamespace, "--dragging")]: dragging
  });
  React.useEffect(() => {
    if (!dragging) {
      changeZoomOutputHiding(true);
      setTimeout(() => changeZoomOutputHiding(false), 350);
    }
  }, [dragging]);
  const renderThumbOutput = (className, hidden) => {
    const props = _objectSpread__default["default"]({}, outputProps);
    if (hidden) props['aria-hidden'] = true;
    return /*#__PURE__*/React__default["default"].createElement("output", _extends__default["default"]({
      className: className
    }, props), getThumbValueLabel(index));
  };
  inputProps.id = "".concat(id, "__input-").concat(index);
  inputProps['aria-labelledby'] = "".concat(id, "__label");
  const primaryOutputClassnames = classNames__default["default"]("".concat(thumbNamespace, "__output"), {
    ["".concat(thumbNamespace, "__output--hide")]: isThumbDragging(index)
  });
  const secondaryOutputClassnames = classNames__default["default"]("".concat(thumbNamespace, "__zoom-output"), {
    ["".concat(thumbNamespace, "__zoom-output--show")]: isThumbDragging(index),
    ["".concat(thumbNamespace, "__zoom-output--hiding")]: zoomOutputHiding
  });
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(thumbNamespace, "-container"),
    style: {
      left: "".concat(getThumbPercent(index) * 100, "%")
    }
  }, void 0, renderThumbOutput(secondaryOutputClassnames, true), /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    className: thumbClassnames
  }, thumbProps), /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(thumbNamespace, "__inner-circle")
  }), /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {
    component: "div"
  }, void 0, /*#__PURE__*/React__default["default"].createElement("input", _extends__default["default"]({
    ref: inputRef
  }, utils.mergeProps(inputProps, focusProps))))), renderThumbOutput(primaryOutputClassnames));
};
var SliderThumb$1 = SliderThumb;
const getStepsAmount = (step, minValue, maxValue) => {
  if (typeof step !== 'number' || typeof minValue !== 'number' || typeof maxValue !== 'number') return 0;
  if (step < 1 || minValue < 0 || maxValue <= 0) return 0;
  if (minValue > maxValue) return 0;
  return Math.ceil((maxValue - minValue) / step);
};
var getStepsAmount$1 = getStepsAmount;
const getValueAsArray = value => {
  if (typeof value === 'number') return [value];
  return value;
};
var getValueAsArray$1 = getValueAsArray;
const Slider = /*#__PURE__*/function () {
  const Slider = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      'aria-label': _willDeprecate$ariaLabel,
      className,
      defaultValue,
      disabled = false,
      format = value => value,
      id,
      isDisabled: _willDeprecate$isDisabled,
      label,
      maxValue = 100,
      minValue = 0,
      prefix,
      srLabel,
      step = 1,
      suffix,
      type = 'single',
      value
    } = props;
    const ownRef = React.useRef(null);
    const trackRef = ref || ownRef;
    const stepsAmount = React.useMemo(() => getStepsAmount$1(step, minValue, maxValue), [step, minValue, maxValue]);
    const computedDisabled = React.useMemo(() => typeof _willDeprecate$isDisabled !== 'undefined' ? _willDeprecate$isDisabled : disabled, [disabled, _willDeprecate$isDisabled]);
    const componentId = context.useId(id);
    const state = slider$1.useSliderState(_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      defaultValue: getValueAsArray$1(defaultValue),
      isDisabled: computedDisabled,
      numberFormatter: {
        format
      },
      value: getValueAsArray$1(value)
    }));
    const {
      labelProps,
      outputProps,
      trackProps
    } = slider.useSlider(_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      'aria-label': _willDeprecate$ariaLabel || srLabel,
      value: getValueAsArray$1(value),
      defaultValue: getValueAsArray$1(defaultValue)
    }), state, trackRef);
    const {
      getThumbPercent
    } = state;
    labelProps.id = "".concat(componentId, "__label");
    outputProps.htmlFor = "".concat(componentId, "__input-0");
    if (type === 'range') outputProps.htmlFor += " ".concat(componentId, "__input-1");
    const sliderClassnames = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--disabled")]: computedDisabled,
      ["".concat(namespace, "--padding-left")]: !prefix,
      ["".concat(namespace, "--padding-right")]: !suffix
    });
    const getTrackStyle = () => {
      const percentages = [getThumbPercent(0), getThumbPercent(1)];
      if (type === 'range') {
        return {
          width: "".concat((percentages[1] - percentages[0]) * 100, "%"),
          left: "".concat(percentages[0] * 100, "%")
        };
      }
      return {
        width: "".concat(percentages[0] * 100, "%")
      };
    };
    const renderLabel = () => {
      const hasA11yLabel = !!(_willDeprecate$ariaLabel || srLabel);
      return /*#__PURE__*/React__default["default"].createElement("label", _extends__default["default"]({
        className: "".concat(namespace, "__label")
      }, labelProps), label && /*#__PURE__*/_jsx__default["default"]("span", {
        "aria-hidden": hasA11yLabel || undefined
      }, void 0, label), hasA11yLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, _willDeprecate$ariaLabel || srLabel));
    };
    const getStepsDots = () => {
      const dots = [];
      for (let i = 1; i < stepsAmount; i += 1) {
        dots.push(/*#__PURE__*/_jsx__default["default"]("span", {
          className: "".concat(namespace, "__step"),
          style: {
            left: "".concat(step * i / (maxValue - minValue) * 100, "%")
          }
        }, "".concat(componentId, "-dot-").concat(i)));
      }
      return dots;
    };
    const renderTrack = () => {
      const sliderThumbCommonProps = _objectSpread__default["default"]({
        state,
        trackRef,
        id: componentId,
        disabled: computedDisabled
      }, outputProps);
      return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
        className: "".concat(namespace, "__track-container"),
        ref: trackRef
      }, trackProps), /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(namespace, "__track")
      }), stepsAmount >= 2 && stepsAmount <= 10 && getStepsDots(), /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(namespace, "__track-completed"),
        style: getTrackStyle()
      }), /*#__PURE__*/React__default["default"].createElement(SliderThumb$1, _extends__default["default"]({
        index: 0
      }, sliderThumbCommonProps)), type === 'range' && /*#__PURE__*/React__default["default"].createElement(SliderThumb$1, _extends__default["default"]({
        index: 1
      }, sliderThumbCommonProps)));
    };
    return /*#__PURE__*/_jsx__default["default"]("div", {
      className: sliderClassnames
    }, void 0, renderLabel(), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__data-container")
    }, void 0, prefix && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__prefix")
    }, void 0, prefix), renderTrack(), suffix && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__suffix")
    }, void 0, suffix)));
  });
  Slider.displayName = 'Slider';
  return Slider;
}();
var Slider$1 = Slider;
exports.Slider = Slider$1;
exports["default"] = Slider$1;
